export default __webpack_public_path__ + "static/media/siouxFalls.badbecaa.jpg";